import { BaseError } from '../base/base.error';
export class ExecutionBaseError extends BaseError {
    cause;
    errorResponse;
    timestamp;
    context = {};
    lineNumber;
    functionality = 'regular';
    constructor(message, options = {}) {
        super(message, options);
        // Defined, not assigned: assignment throws when `Error.prototype` is frozen (task runner secure mode)
        Object.defineProperty(this, 'name', {
            value: this.constructor.name,
            writable: true,
            enumerable: true,
            configurable: true,
        });
        this.timestamp = Date.now();
        const { cause, errorResponse } = options;
        if (cause instanceof ExecutionBaseError) {
            this.context = cause.context;
        }
        else if (cause && !(cause instanceof Error)) {
            this.cause = cause;
        }
        if (errorResponse)
            this.errorResponse = errorResponse;
    }
    toJSON() {
        return {
            message: this.message,
            lineNumber: this.lineNumber,
            timestamp: this.timestamp,
            name: this.name,
            description: this.description,
            context: this.context,
            cause: this.cause,
        };
    }
}
//# sourceMappingURL=execution-base.error.js.map